import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';

import VueMeta from 'vue-meta';
Vue.use(VueMeta);

import VueFbCustomerChat from 'vue-fb-customer-chat'
Vue.use(VueFbCustomerChat, {
  page_id: '179163795468160', // 輸入 Facebook Page ID,
  theme_color: '#6699cc', // 設定messenger顏色
  locale: 'zh_TW', // 設定語言
  logged_out_greeting: '嗨~有問題可以私訊我喔！', //登入狀態歡迎詞
  logged_in_greeting: '您好，很高興為您服務' //登出(未登入)狀態歡迎詞
})

import VueSocialSharing from 'vue-social-sharing'
Vue.use(VueSocialSharing);


// import { library } from '@fortawesome/fontawesome-svg-core'
// import { faFacebookSquare, faLine } from '@fortawesome/free-brands-svg-icons'
// import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
// library.add(faFacebookSquare, faLine)
// Vue.component('font-awesome-icon', FontAwesomeIcon)


import './assets/scss/_app.scss'

Vue.config.productionTip = false;

Vue.config.devtools = true;
Vue.config.performance = true;
Vue.config.debug = true;

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
